import { useEffect } from "react";

import { useAppDispatch, useAppSelector } from "./useRedux";
import { setViewBrandId } from "../store/brands/slice";
import {
  selectActiveBrandsState,
  selectBrandState,
  selectSelectedBrandState,
} from "../store/selectors/brands";

/**
 * Syncs selected brand to main brand when list changes and current selection is no longer valid.
 */
export function useSyncSelectedBrandToMain(): void {
  const dispatch = useAppDispatch();
  const brandsWithCompetitors = useAppSelector(selectActiveBrandsState);
  const mainBrand = useAppSelector(selectBrandState);
  const selectedBrand = useAppSelector(selectSelectedBrandState);
  const selectedBrandId = selectedBrand?.id ?? null;

  useEffect(() => {
    if (!mainBrand || !brandsWithCompetitors?.length) return;

    const isMainBrandAvailable = brandsWithCompetitors.some((b) => b.id === mainBrand.id);
    if (!isMainBrandAvailable) return;

    const isSelectedValid =
      selectedBrandId != null &&
      brandsWithCompetitors.some((b) => b.id === selectedBrandId);
    if (isSelectedValid) return;

    dispatch(setViewBrandId(mainBrand.id));
  }, [brandsWithCompetitors, dispatch, mainBrand, selectedBrandId]);
}
